import React, { useEffect, useState, useContext } from 'react'
// * Kendo dependencies
import { Grid, GridColumn as Column, GridNoRecords } from '@progress/kendo-react-grid';
// import { ExcelExport } from '@progress/kendo-react-excel-export';
import { Loader } from "@progress/kendo-react-indicators";
// * CSS
import './wizard.css'
// * Helpers
import Notifications, { ERROR_NOTIFICATION } from '../../helpers/notifications';
import { useTranslation } from 'react-i18next';
import MatrixContext from '../../assets/Constants/matrixContext';
// * Axios
import API, { AMS } from "../../services/api";
// Context
import AuthContext from '../../context/Auth/AuthContext';
import { VIEW } from '../../assets/Constants/actionsTypes';

/*List of icons used in this component*/
/**Important: to see the full icons list visit: https://react-icons.github.io/react-icons */
import { ImArrowRight, ImArrowLeft } from 'react-icons/im'

const Step8 = (props) => {
    // * we call the hook to make translations
    const { t } = useTranslation('common');
    // list of data
    const [gridDataList, setGridDataList] = useState([])
    // user information from context
    const { user } = useContext(AuthContext);
    // const _export = useRef(null);

    //show_report
    const [showGapReport, setShowGapReport] = useState('');

    const [maxPull, setMaxPull] = useState(0);

    const [taskIdForPull, setTaskIdForPull] = useState(0);

    const [doPull, setDoPull] = useState(false);

    // we use useEffect to call the function that returns the step1 data
    useEffect(() => {
        if (props.activeStep === 9) {
            checkIsReadyForAssessment();
        }
    }, [props.activeStep]);// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (doPull && props.activeStep === 9) {
            const interval = setInterval(() => {

                if (maxPull < 3) {
                    checkTaskStatus();

                } else {
                    setDoPull(false);
                    setMaxPull(0);
                }
            }, 5000);
            return () => clearInterval(interval);
        }
    }, [doPull, maxPull]);// eslint-disable-line react-hooks/exhaustive-deps

    const checkIsReadyForAssessment = async () => {
        try {
            const response = await API.get(`Model/getModelFlags?modelId=${props.modelData.modelid}`);

            if (response.data.code === 100) {
                const isReadyForAssessment = response.data.data.isReadyForAssessment
                if (isReadyForAssessment) {
                    setShowGapReport('report')
                    getStep8Data();
                } else {
                    setShowGapReport('noreport')
                }
            }
        } catch (e) {
            Notifications.notify(String(e), ERROR_NOTIFICATION);
            setGridDataList([]);
            setShowGapReport('noreport')
            console.log(e)
        }
    }

    // * This line is used so that the numerical inputs have the thousands separator with comma
    const addCommas = num => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    // Gets the data to bind the Gaps Report Grid
    const getStep8Data = async () => {
        try {
            const response = await AMS.get(`/gaps_report/${MatrixContext.MODEL}/${props.modelData.modelid}`);
            if (response.data.result !== 1) {
                setGridDataList([]);
            } else {
                response.data.data.map((element, i) => {
                    element[1] = addCommas(element[1]);
                    element[2] = addCommas(element[2]*100)+ "%";
                    element[3] = addCommas(element[3]);
                    element[4] = addCommas(element[4]*100)+ "%";
                    element[5] = addCommas(element[5]);
                    element[6] = addCommas(element[6]*100) + "%";
                });
                setGridDataList(response.data.data);
            }
        } catch (e) {
            Notifications.notify(String(e), ERROR_NOTIFICATION);
            setGridDataList([]);
            console.log(e)
        }
    }

    // * This function is called when the PREVIOUS arrow is clicked.
    // * It is passed as parameter to each step 
    const onPreviousClick = () => {
        props.changeStep(8);
    }

    // * This function is called when the NEXT arrow is clicked.
    // * It is passed as parameter to each step 
    const onNextClick = () => {
        props.changeStep(10);
    }

    // // * Called in the Export to Excel button
    // const excelExport = () => {
    //     if (gridDataList === [] || gridDataList === null || gridDataList.length <= 0) {
    //         Notifications.notify(t(`model.noExcelData`), ERROR_NOTIFICATION);
    //         return;
    //     } else {
    //         if (_export.current !== null) {
    //             _export.current.save();
    //         }
    //     }
    // };

    //
    const calculateGapAssessment = async () => {
        console.log("YEP-> ", MatrixContext);
        try {
            const response = await API.post(`Scheduler/addTask`, null, {
                params: {
                    ctxtcode: MatrixContext.MODEL,
                    scenarioid: props.modelData.modelid,
                    opcode: 'CAL',
                    usrcode: user ? user.email : 'get_user_error',
                    customparams: JSON.stringify({ runblocks: ['load_data', 'gaps'] })
                }
            });
            if (response.data.code === 100) {
                setTaskIdForPull(response.data.data);
                setShowGapReport('wait');
                setMaxPull(0);
                setDoPull(true);
            } else {
                Notifications.notify(response.data.code, ERROR_NOTIFICATION);
            }
        } catch (e) {
            Notifications.notify(String(e), ERROR_NOTIFICATION);
            setGridDataList([]);
            setShowGapReport('');
            console.log(e)
        }
    }

    const checkTaskStatus = async () => {
        try {
            const response = await API.post(`Scheduler/getTaskStatus`, null, {
                params: {
                    taskid: taskIdForPull
                }
            });
            if (response.data.code === 100) {
                if (response.data.data === 100) {

                    setShowGapReport('report');
                    getStep8Data();
                    setDoPull(false);
                    props.setFlags();
                } else {
                    if (response.data.data === 20 || response.data.data === 200 || response.data.data === 300) {
                        setShowGapReport('error');
                        setDoPull(false);
                    }
                }
            }
        } catch (e) {
            Notifications.notify(String(e), ERROR_NOTIFICATION);
            console.log(e);
        }
        setMaxPull(maxPull + 1);
    }

    const titleStyle = (props) => {
        return (
            <span className="grids_titles_styles">
                {props.title}
            </span>
        );
    }

    const displayInformation = () => {
        switch (showGapReport) {
            case 'noreport':
                return (
                    <div>
                        <h4 style={{ color: "#230050" }}>{t('model.no_report')}</h4>
                    </div>
                )
            case 'error':
                return (
                    <div>
                        <h4 style={{ color: "#230050" }}>{t('model.error_report', { id: taskIdForPull })}</h4>
                    </div>
                )
            case 'wait':
                return (
                    <div>
                        <Loader size="large" type="converging-spinner" />
                    </div>
                )
            case 'report':
                return (
                    <>
                        {/**Si se desea exportar a Excel solo se debe meter todo el grid dentro de las etiquetas comentadas abajo y descomentar el boton*/}
                        {/**<ExcelExport data={gridDataList} ref={_export}></ExcelExport>**/}
                        <Grid style={{ height: '100%' }} data={gridDataList} resizable={true}>
                            {/* this is the message when there are no records */}
                            <GridNoRecords>{t('grids.no_records')}</GridNoRecords>
                            {/* columns of the grid */}
                            {/**
                             * <GridToolbar>
                                <button
                                    title={`${t('model.excelDocName')} - ${props.modelData.name}`}
                                    className="k-button k-primary"
                                    onClick={excelExport}
                                >
                                    {t('model.excelExport_btn')}
                                </button>
                            </GridToolbar>
                             * 
                             */}

                            <Column headerClassName="grid-header-columns" field="0" title={t('model.step8_benefit_name')} width="150" headerCell={titleStyle} />
                            <Column headerClassName="grid-header-columns" title={t('model.step8_cov_gap')}>
                                <Column headerClassName="grid-header-columns" className="grid-aling-numbers" field="1" title={t('model.step8_abs')} width="140" />
                                <Column headerClassName="grid-header-columns" className="grid-aling-numbers" field="2" title={t('model.step8_rel')} width="140" />
                            </Column>
                            <Column headerClassName="grid-header-columns" title={t('model.step8_ade_gap')} >
                                <Column headerClassName="grid-header-columns" className="grid-aling-numbers" field="3" title={t('model.step8_abs')} width="140" />
                                <Column headerClassName="grid-header-columns" className="grid-aling-numbers" field="4" title={t('model.step8_rel')} width="140" />
                            </Column>
                            <Column headerClassName="grid-header-columns" title={t('model.step8_fin_gap')} >
                                <Column headerClassName="grid-header-columns" className="grid-aling-numbers" field="5" title={t('model.step8_abs')} width="140" />
                                <Column headerClassName="grid-header-columns" className="grid-aling-numbers" field="6" title={t('model.step8_rel')} width="140" />
                            </Column>
                        </Grid>
                    </>
                )
            default:
                return null
        }
    }

    return (
        <div className="col-md-12">
            <div className="row">
                <h6>{t('model.step8_desc')}</h6>
            </div>
            <div className="row_attrs container_steps">
                <div className="row mb-2" style={{ height: "5%" }}>
                    {props.isActionView === VIEW ? null :
                        <button
                            className="btn btn-primary ilo-btn"
                            onClick={calculateGapAssessment}
                        >
                            {t('model.calculate')}
                        </button>
                    }
                </div>
                <div className="row" style={{ height: "90%" }}>
                    <div className="col-sm-12 align-items-center" style={{ textAlign: "center" }}>
                        {
                            displayInformation()
                        }
                    </div>
                </div>
            </div>
            <div className="row arrows_position">
                <div className="col-sm-12">
                    <button className="btn_style" type="button" onClick={() => { onPreviousClick(); }} ><ImArrowLeft /></button>
                    <button className="btn_style" type="button" onClick={() => { onNextClick(); }} ><ImArrowRight /></button>
                </div>
            </div>
        </div>
    );
}

export default Step8